import L from 'leaflet';

// Icon color directory mapping
export const ICON_COLORS = {
    RED: 'red',
    GREEN: 'green',
    BLUE: 'blue',
} as const;

// Base icon URL template
const ICON_BASE_URL = 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-';

// Icon factory function
const createIcon = (color: string) => new L.Icon({
    iconUrl: `${ICON_BASE_URL}${color}.png`,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

// Color-based icon instances
export const redIcon = createIcon(ICON_COLORS.RED);
export const greenIcon = createIcon(ICON_COLORS.GREEN);
export const blueIcon = createIcon(ICON_COLORS.BLUE);